<template>
    <div class="content">
        <sub-title title="联系我们"></sub-title>

        <div class="contact-info">
            <div>
                <img src="/images/about/phone.png" />
                <label>电话: 400-780-9998 (工作时间: 8:00-17:30)</label>
            </div>
            <div>
                <img src="/images/about/pos.png" />
                <label>地址: 河北省石家庄市中山东路126号凯嘉大厦10层</label>
            </div>
        </div>

        <div class="bdwindow">
            <img src="/images/about/map.jpg" alt="">
        </div>
    </div>
</template>

<script>
import SubTitle from '../../index/component/sub-title.vue';
export default {
    components: { SubTitle },
    data() {
        return {
            center: { lng: 114.511191, lat: 38.048417 },
            zoom: 20, //缩放级别
            scroll: true, //地图缩放
            dragging: true, //地图拖拽
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
.content {
    padding-top: 72px;
    padding-bottom: 141px;

    .contact-info {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        color: #333333;
        padding: 0px 96px;
        margin-top: 62px;

        img {
            width: 18px;
            height: 18px;
            vertical-align: middle;
        }
    }
}
.bdwindow {
    height: 442px;
    width: 1118px;
    margin: 0 auto;
    margin-top: 44px;
}
</style>
